import IconNameEnum from "constants/IconNameEnum";
import React from "react";
import BaseBadge from "./BaseBadge";

interface IProps {
    icon: IconNameEnum;
    className?: string;
    color?: "default" | "white";
    badge?: string | number;
    hoverTitle?: string;
    rotate?: boolean;
    onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}

class BaseIcon extends React.Component<IProps> {
    private handleOnClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        const { onClick } = this.props;
        onClick && onClick(event);
    };
    public render(): JSX.Element {
        const { icon, className, color, badge, hoverTitle, rotate } = this.props;
        const iconName = color === "white" ? `${icon} b` : `${icon}`;

        return (
            <>
                <img
                    className={["align-self-center ocq-icon", rotate ? "rotated" : "", className].join(" ")}
                    alt="icon"
                    src={require(`assets/icons/${iconName}.svg`)}
                    title={hoverTitle}
                    onClick={this.handleOnClick}
                />
                <BaseBadge content={badge} />
            </>
        );
    }
}

export { BaseIcon as Unconnected };
export default BaseIcon;
